export default __webpack_public_path__ + "static/media/Flag_of_the_Torres_Strait_Islanders.e396daca.svg";